// favicon.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FaviconService {
  updateFavicon(url: string): void {
    const favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
    favicon.href = url;
  }
}

